import { createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { Groups as CustomerGroups } from '@/components/settings-route/customer/groups'

export const Route = createFileRoute('/_auth/customers/groups')({
  component: CustomGroupsWrapper,
})

export default function CustomGroupsWrapper() {
  return (
    <Layout.Body>
      <CustomerGroups />
    </Layout.Body>
  )
}
